import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { EngagementService } from 'src/app/shared/services/engagement/engagement.service';
import * as _ from 'lodash';
import { NgIf } from '@angular/common';
import { LtmsWidgetToolsComponent } from '../../../../shared/components/ltms-widget-tools/ltms-widget-tools.component';
import { LtmsDataTableV2Component } from '../../../../shared/components/ltms-data-table-v2/ltms-data-table-v2.component';
import { LtmsErrorComponent } from '../../../../shared/components/ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';

@Component({
    selector: 'app-project-engagement-page-view',
    templateUrl: './project-engagement-page-view.component.html',
    styleUrls: ['./project-engagement-page-view.component.scss'],
    imports: [NgIf, LtmsWidgetToolsComponent, LtmsDataTableV2Component, LtmsErrorComponent, LtmsLoaderComponent]
})
export class ProjectEngagementPageViewComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isDeviationEnabled = false;
  deviationComparisonLabel = '';
  private pageViewSummary: any;
  private prevStateDeviationEnabled = false;
  //variable declaration
  isDataProcessed: boolean = false;
  isDataAvailable: boolean = false;
  isDataLoaded: boolean = false;
  errorCode: string = '404';
  tableHeader: any[] = [];
  tableData: any[] = [];
  footerData: any = {};
  columns: any[] = [];
  mainDiscription: string = 'Analyze customer engagement with each conversation page (e.g., Page Number 1) across various devices to understand completion rates and optimize conversation flow.';
  // restrictToday: boolean = localStorage.getItem('restrictToday') !== null
  //   ? JSON.parse(localStorage.getItem('restrictToday')!)
  //   : false;
  restrictToday: boolean = false;
  // pagingDetails: any = {
  //   start: 0,
  //   end: 0,
  //   pageSize: 10,
  //   pageNumber: 1,
  //   total: 0,
  //   totalpages: 0
  // }
  // pagingButtons: any = {
  //   isNext: false,
  //   isPrevious: false,
  //   isLast: false,
  //   isFirst: false
  // }

  widgetConfig: any = {
    //TODO
    "download": {
      enable: true,
      componentId: '',
      data: {
        "accountOrProjectName": '',
        "headers": [],
        "body": [],
        rows: [],
        columns: [],
        title: "Engagement Page View",
        fileName: "Engagement Page View"
      }
    },
    "fullscreen": {
      enable: false,
      componentId: 'tableId'
    }
  }
  dates = {
    startDate: '',
    endDate: ''
  };

  constructor(
    private engagementService: EngagementService,
    private _helpers: HelpersService,

  ) {
    this._helpers.datePicker.subscribe(data => {
      if (data) {
        this.dates.startDate = data.startDate;
        this.dates.endDate = data.endDate;
        this.deviationComparisonLabel = this._helpers.getDeviationComparisonLabel(data);
        this.restrictToday = !this.engagementService.is_valid_date_range(this.dates.endDate, this.dates.startDate)
      }
    })
  }

  ngOnInit(): void {
    // const storedValue = localStorage.getItem('restrictToday');
    // if (storedValue !== null) {
    //   // Parse and set `restrictToday` if the value exists
    //   this.restrictToday = JSON.parse(storedValue);
    // } else {
    //   // Initialize with default value and store it in localStorage
    //   this.restrictToday = false;
    //   localStorage.setItem('restrictToday', JSON.stringify(this.restrictToday));
    // }
    this._helpers.appState.subscribe((response: any) => {
      if (response && !response.pending) {
        this.getOverallSummary({
          startDate: this.dates.startDate,
          endDate: this.dates.endDate,
        });
        this.restrictToday = !this.engagementService.is_valid_date_range(this.dates.endDate, this.dates.startDate)
      }
    })
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   this.getOverallSummary()
  // }

  //fetch data from stats v3 and passing all the parameters into the api
  // private getOverallSummary(): void {

  //   this.isDataProcessed = false;
  //   this.isDataAvailable = false;
  //   this.tableData = [];
  //   var params = this.engagementService.getPageViewParams({      
  //     query_type:4,
  //     trend_type:1})
  //     this.isDataLoaded = false;
  //     this.engagementService.getEngagementSummary(params).subscribe({
  //       next: (response) => {          
  //       if (response && response.data.code === 0 &&
  //         response.data.overall_summary_details &&
  //         response.data.overall_summary_details.summary &&
  //         response.data.overall_summary_details.summary.current.device_level_page_views &&
  //         Object.keys(response.data.overall_summary_details.summary.current.device_level_page_views).length > 0) {
  //         this.processData(response.data.overall_summary_details.summary);
  //         this.isDataLoaded = true;
  //       } else {
  //         this.isDataProcessed = true;
  //         this.isDataAvailable = false;
  //         this.isDataLoaded = true;
  //         this.errorCode = '404'
  //       }
  //     },
  //     error: (err) => {
  //       this.isDataAvailable = false
  //       this.isDataLoaded = true;
  //       if (err.status == '500') {
  //         this.errorCode = '500'
  //       }  
  //       else if (err.status == "408") {
  //         this.errorCode = '408'
  //       }
  //     }
  //   })
  // }
  private getOverallSummary(dates: { startDate: string; endDate: string }): void {

    const formatDate = (date: Date): string => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}${month}${day}`;
    };
    const startDate = (dates.startDate);
    const endDate = (dates.endDate);
    // const today = new Date();
    // const yesterday = new Date();
    // yesterday.setDate(today.getDate() - 1);
    // if (startDate === formatDate(today) || startDate === formatDate(yesterday)) {

    //   this.restrictToday = true;
    //   this.isDataLoaded = true;

    //   localStorage.setItem('restrictToday', JSON.stringify(this.restrictToday));
    //   return;

    // }

    // // Continue with the existing logic
    // this.restrictToday = false

    this.isDataProcessed = false;
    this.isDataAvailable = false;
    this.tableData = []; // Empty the table data before loading new data
    this.isDataLoaded = false;  // Set data loading state to false
    const params = this.engagementService.getPageViewParams({
      query_type: 4,
      trend_type: 1,
      is_deviation_enabled: this.isDeviationEnabled,
    });
    // this.restrictToday = false
    this.isDataLoaded = false;
    this.engagementService.getEngagementSummary(params).subscribe({
      next: (response) => {
        // Reset or empty the array before processing new data
        this.tableData = []; // Ensure old data is cleared before adding new
        if (
          response &&
          response.data.code === 0 &&
          response.data.overall_summary_details &&
          response.data.overall_summary_details.summary &&
          response.data.overall_summary_details.summary.current?.device_level_page_views &&
          Object.keys(response.data.overall_summary_details.summary.current?.device_level_page_views || {}).length > 0
        ) {
          this.pageViewSummary = response.data.overall_summary_details.summary;
          this.processData(this.pageViewSummary);
          this.isDataLoaded = true;
        } else if (
          response &&
          response.data.code === 0 &&
          response.data.overall_summary_details &&
          response.data.overall_summary_details.summary &&
          response.data.overall_summary_details.summary.current &&
          this.isDeviationEnabled &&
          response.data.overall_summary_details.summary.previous
        ) {
          this.pageViewSummary = response.data.overall_summary_details.summary;
          this.processData(this.pageViewSummary);
          this.isDataLoaded = true;
        } else {
          this.isDataProcessed = true;
          this.isDataAvailable = false;
          this.isDataLoaded = true;
          this.errorCode = '404';
        }
      },
      error: (err) => {
        this.isDataAvailable = false;
        this.isDataLoaded = true;
        if (err.status === 500) {
          this.errorCode = '500';
        } else if (err.status === 408) {
          this.errorCode = '408';
        }
      },
    });
  }


  /** Strip device prefix when present; pages starting with page_ are kept as-is. */
  private normalizePageId(pageName: string, device: string): string {
    if (device === 'desktop' && pageName.startsWith('desktop_')) {
      return pageName.slice('desktop_'.length);
    }
    if (device === 'phone' && pageName.startsWith('phone_')) {
      return pageName.slice('phone_'.length);
    }
    if (device === 'tablet' && pageName.startsWith('tablet_')) {
      return pageName.slice('tablet_'.length);
    }
    return pageName;
  }

  /** API uses mobile for phone device bucket. */
  private getApiDeviceKey(device: string): string {
    return device === 'phone' ? 'mobile' : device;
  }

  // prepare mapping of page detail for different devices
  private getPageViewMappings(): any {
    const mapping: any = { pg_mapping: {}, defaultData: {}, pageApiKeys: {} };
    let count = 0;
    const pageViewDetails = this._helpers.getBrandDetails()?.page_view_details;

    if (!pageViewDetails?.length) {
      return mapping;
    }

    mapping.pg_mapping['name'] = {
      header: 'Devices',
      dataKey: 'name',
      dataType: 'string',
      enabled: true,
      style: {
        headerTextAlign: 'left',
        cellTextAlign: 'left'
      },
      order: count
    };
    count++;

    const allPageIDs = new Set<string>();

    pageViewDetails.forEach((page: any) => {
      if (page && page.device && !page.is_deleted) {
        const pageID = this.normalizePageId(page.page_name, page.device);
        allPageIDs.add(pageID);

        if (!mapping.pg_mapping[pageID]) {
          mapping.pg_mapping[pageID] = {
            header: page.display_name,
            dataKey: pageID,
            dataType: 'string',
            enabled: true,
            style: {
              headerTextAlign: 'right',
              cellTextAlign: 'right'
            },
            order: count
          };
          count++;
        }

        if (!mapping.defaultData[page.device]) {
          mapping.defaultData[page.device] = {
            name: page.device.charAt(0).toUpperCase() + page.device.slice(1)
          };
        }
        if (!mapping.pageApiKeys[page.device]) {
          mapping.pageApiKeys[page.device] = {};
        }

        mapping.pageApiKeys[page.device][pageID] = page.page_name;
        mapping.defaultData[page.device][pageID] = 0;
      }
    });

    for (const device in mapping.defaultData) {
      for (const pageID of allPageIDs) {
        if (mapping.defaultData[device][pageID] === undefined) {
          mapping.defaultData[device][pageID] = 0;
        }
      }
    }

    return mapping;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDeviationEnabled'] && this.prevStateDeviationEnabled !== this.isDeviationEnabled) {
      this.prevStateDeviationEnabled = this.isDeviationEnabled;
      this.updateColumnDeviationFlags();
      if (this.pageViewSummary) {
        this.processData(this.pageViewSummary);
      }
    }
  }

  private updateColumnDeviationFlags(): void {
    this.columns = this.columns.map((column: any) => ({
      ...column,
      is_deviation_enabled: !!this.isDeviationEnabled && column.dataKey !== 'name'
    }));
  }

  // preparing data for datatable
  private processData(data): void {
    // Reset the arrays and objects to clear previous data
    this.columns = [];
    this.tableData = [];
    this.footerData = {};
    var currentData = (data && data.current) ? data.current : {};
    var mapping: any = this.getPageViewMappings();
    if (this.isDeviationEnabled && data?.previous && (_.isEmpty(currentData) || !currentData.device_level_page_views)) {
      currentData = { ...currentData, device_level_page_views: currentData.device_level_page_views || {} };
    }

    if (!_.isEmpty(currentData) && !_.isEmpty(mapping) && !_.isEmpty(mapping.defaultData)) {
      const footerData: any = { name: 'Total' };
      Object.keys(mapping.pg_mapping).forEach((pageID) => {
        if (pageID !== 'name') {
          footerData[pageID] = 0;
        }
      });

      const previousData = (data && data.previous) ? data.previous : {};
      const previousViews = previousData.device_level_page_views || {};
      const currentViews = currentData.device_level_page_views || {};

      _.forOwn(mapping.pageApiKeys, (pageKeys: Record<string, string>, rowKey: string) => {
        const apiDeviceKey = this.getApiDeviceKey(rowKey);
        const devicePageViews = currentViews[apiDeviceKey]?.page_views || {};

        if (!mapping.defaultData[rowKey]) {
          mapping.defaultData[rowKey] = {
            name: rowKey.charAt(0).toUpperCase() + rowKey.slice(1)
          };
        }
        if (this.isDeviationEnabled) {
          mapping.defaultData[rowKey].deviations = mapping.defaultData[rowKey].deviations || {};
        }

        _.forOwn(pageKeys, (fullPageName: string, pageID: string) => {
          const count = devicePageViews[fullPageName]?.count ?? 0;
          mapping.defaultData[rowKey][pageID] = this.engagementService.formatNumber(count) || 0;
          footerData[pageID] += count;

          if (this.isDeviationEnabled) {
            const prevCount = _.get(previousViews, `${apiDeviceKey}.page_views.${fullPageName}.count`, 0);
            mapping.defaultData[rowKey].deviations[pageID] = Helpers.getFieldDeviation(count, prevCount);
          }
        });
      });

      // Assign columns and data
      this.columns = Object.values(mapping.pg_mapping);
      this.updateColumnDeviationFlags();
      this.tableData = Object.values(mapping.defaultData);
      if (this.isDeviationEnabled) {
        footerData.deviations = {};
        _.forOwn(footerData, (count, pageID) => {
          if (pageID === 'name' || pageID === 'deviations') {
            return;
          }
          let prevTotal = 0;
          _.forOwn(mapping.pageApiKeys, (pageKeys: Record<string, string>, rowKey: string) => {
            const apiDeviceKey = this.getApiDeviceKey(rowKey);
            const fullPageName = pageKeys[pageID];
            if (fullPageName) {
              prevTotal += _.get(previousViews, `${apiDeviceKey}.page_views.${fullPageName}.count`, 0);
            }
          });
          footerData.deviations[pageID] = Helpers.getFieldDeviation(count, prevTotal);
        });
      }
      for (const key in footerData) {
        if (key !== "name" && key !== "deviations") {
          footerData[key] = this.engagementService.formatNumber(footerData[key]);
        }
      }
      this.footerData = footerData;
      this.widgetConfig['download']['data']['columns'] = this.columns.map(item => ({
        header: item.header,
        dataKey: item.dataKey,
        order: item.order + 1
      }));
      this.widgetConfig['download']['data']['rows'] = [... this.tableData, ...[this.footerData]]
      this.isDataAvailable = true;
    } else {
      this.isDataAvailable = false;
    }
  }

  //not needed now, If needed please enable it
  // updatePagingDetails(totalfeeds: number, pageNumber: number) {
  //   if (totalfeeds > 0) {
  //     pageNumber = (pageNumber > 0) ? pageNumber : 0;
  //     let start = (pageNumber > 0) ? ((pageNumber - 1) * this.pagingDetails.pageSize) + 1 : 0;
  //     let end = (pageNumber > 0) ? (pageNumber * this.pagingDetails.pageSize) : 0;
  //     end = (totalfeeds < this.pagingDetails.pageSize) ? totalfeeds : end;
  //     this.pagingDetails = {
  //       start: start,
  //       end: end,
  //       pageSize: 10,
  //       pageNumber: pageNumber,
  //       total: totalfeeds,
  //       totalpages: Math.round(totalfeeds / 10)
  //     }
  //   } else {
  //     this.pagingDetails = {
  //       start: 0,
  //       end: 0,
  //       pageSize: 10,
  //       pageNumber: 1,
  //       total: 0,
  //       totalpages: 0
  //     }
  //   }
  //   this.pagingButtons.isNext = false;
  //   this.pagingButtons.isFirst = false;
  //   this.pagingDetails.isPrevious = false;
  //   this.pagingButtons.isLast = false;

  //   if (this.pagingDetails.pageNumber < this.pagingDetails.totalpages) {
  //     this.pagingButtons.isNext = true;
  //     this.pagingButtons.isLast = true;
  //   }

  //   if (this.pagingDetails.pageNumber > 1) {
  //     this.pagingButtons.isFirst = true;
  //     this.pagingDetails.isPrevious = true;
  //   }
  //   if (this.pagingDetails.total < this.pagingDetails.pageSize) {
  //     this.pagingButtons.isNext = false;
  //     this.pagingButtons.isFirst = false;
  //     this.pagingDetails.isPrevious = false;
  //     this.pagingButtons.isLast = false;
  //   }
  // }

  ngOnDestroy(): void {
  }
}